import { Icon } from '@iconify/react';

import ButtonLink, { ButtonLinkProps } from './ButtonLink';

interface IconButtonLinkProps extends Omit<ButtonLinkProps, 'children'> {
  /**
   * The icon name as per the Iconify API. See https://icon-sets.iconify.design/
   * If icon set prefix is omitted, it is assumed to be 'material-symbols'.
   */
  icon: string;
  label?: string;
  paddingSize?: 'sm' | 'md';
}

/**
 * Link which looks like an icon button. Displays an icon based on the iconify package.
 */
export default function IconButtonLink({
  icon,
  label,
  paddingSize = 'md',
  className = '',
  ...rest
}: IconButtonLinkProps) {
  return (
    <ButtonLink className={`icon-button ${className} ${!label ? `even-padding-${paddingSize}` : ''} w-fit`} {...rest}>
      <div className="icon-wrapper">
        <Icon icon={icon.includes(':') ? icon : `material-symbols:${icon}`} height="1.5rem" width="1.5rem" />
      </div>
      {label && <span className="ml-1">{label}</span>}
    </ButtonLink>
  );
}
